import getRequest from 'utils/getRequest'

const path = '/api'

export const getFiltersCountries = () => {
  return getRequest(`${path}/countries?sortBy=name&sortDirection=ASC`)
}

export const getFiltersRegions = () => {
  return getRequest(`${path}/regions`)
}

export const getFiltersEcoregion = () => {
  return getRequest(`${path}/eco-regions`)
}

export const getFiltersTaxonomyClasses = () => {
  return getRequest(`${path}/reports/taxonomy-classes`)
}
